import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth64: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M61.9,67.9s18.2,23.6.2,44.9c-1.5,1.8,13.2-11.8,22.7-11.8s9.6,13,23.2,13,10.9-13.3,23.5-13.3,22.6,14.3,22.6,14.3c0,0-15.7-25.6,0-46.3,0,0-11.9,12-22.4,12s-11-13.6-23.7-14-10.3,14.3-22.7,14.3-23.3-13.1-23.3-13.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M49.2,48.2s2.9,11.2,12.7,19.7c0,0,18,23,.2,44.9,0,0-5.7,4.9-15.5,16.5l-10.8-14.3-2.5-4.5-2.4-6.4-1.3-5.7-1.2-7.5v-16.6l1.7-5.9,2.7-5.2,4.2-4.5,12.2-10.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M154,68.8s-15.3,16.8,0,46.3c0,0,9.1,6.7,17.7,20.3l8.2-16.7,2.7-12.1v-29.1l-1.9-10.6-4-6.6-6.8-10s-2.5,9-16,18.6Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M46.6,129.4s13.1-15.4,15.5-16.5c0,0,14.3-11.8,22.7-11.8s10.1,13,23.2,13,11.4-13.3,23.5-13.3,22.6,14.3,22.6,14.3c0,0,7.8,5.7,17.7,20.3l-11,13.9-13.5,13-10.5,6.6-14,6.2-11.1,2.7h-7.6l-8.1-1.5-8.8-3.5-5.9-3.5-5.6-7.4-6.7-9.9-6.3-7.3-16.1-15.1Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M49.2,48.2l19-12.2,16.7-8.6,5.2-.8h15.1l4-1h14l5.8,1.1,8.7,2.8,7.6,4.4,5.2,3,4.2,4,15.2,9.3s-3.6,10.4-16,18.6-11.6,12-22.4,12-12.7-14-23.7-14-11.3,14.3-22.7,14.3-23.3-13.1-23.3-13.1c0,0-12.4-11-12.7-19.7Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M46.6,129.4l16.1,15.1,6.3,7.3,6.7,9.9,5.6,7.4,5.9,3.5,8.8,3.5,8.1,1.5h7.6l11.1-2.7,14-6.2,10.5-6.6,13.5-13,11-13.9s-53.8,34.2-125.1-6Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M49.2,48.2l19-12.2,16.7-8.6,5.2-.8h15.1l4-1h14l5.8,1.1,8.7,2.8,7.6,4.4,5.2,3,4.2,4,15.2,9.3s-49.2-25.1-120.8-2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119,175.3c-14.9,4-31.1.3-40.8-11.4s-10.8-16.1-18.4-22.7c-10.5-9.2-20.6-19.2-26.1-32.8s-7.1-27.1-2.2-39.3c6.2-15.6,31.6-30.4,47.8-38.7,7.7-4,16.3-2.7,24.8-3.4,36-3.3,41.1,10.5,60.6,20.4,4.7,2.4,8,6.8,10.7,11,6.6,10.5,7.8,21.5,7.9,33.5,0,13.6-2.5,25.4-8.9,37.3-5.1,9.5-10.8,17.8-19,25-10.7,9.4-21.8,17.1-36.3,21Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.6,147.3l-11.5-21s32.4,6,32.4-40.8h84.1s-5.4,40.8,32.4,40.8l-.8,21s-61.2,28.7-136.6,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M61.4,85.5v-38l-9.3,10-4.4,3.2-7.4,4.1-4.1,3.5-4.4,5.3-3.8.4-4.4,5.1-3.5,6.2-1.3,5.3v6.5l1.8,7.6,3.5,10.6,2.9,7.3,2.1,3.5s32.4,6,32.4-40.8Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M145.6,85.5v-30.7h7.6l7.2,4.3,8.2,5.6,4.3,2.6,5.1,7.9,2.6,6.3v17.7l-2.6,27.1s-34.9,3.4-32.4-40.8Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M145.6,85.5H20l3.5-6.2,4.4-5.1,3.8-.4,4.4-5.3,4.1-3.5,7.4-4.1,4.4-3.2,9.3-10,10.5-8.4,10.8-5.4,5.9-1.3,5.6,1.2,4.1.9,6.2,2.2,7.8,3.2,4.7,2.2,6.2,2.6,4.7,2.8,4.6,3.5,3.4,3.7,2.9,1.2h2.8l3.9-1.2h7.6l7.2,4.3,8.2,5.6,4.3,2.6,5.1,7.9,2.6,6.3v4s-35.6,0-34.9,0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.6,147.3l-11.5-21-2.1-3.5-2.9-7.3-3.5-10.6-1.8-7.6v-6.5l1.3-5.3,3.5-6.2,4.4-5.1,3.8-.4,4.4-5.3,4.1-3.5,7.4-4.1,4.4-3.2,9.3-10,10.5-8.4,10.8-5.4,5.9-1.3,5.6,1.2,4.1.9,6.2,2.2,7.8,3.2,4.7,2.2,6.2,2.6,4.7,2.8,4.6,3.5,3.4,3.7,2.9,1.2h2.8l3.9-1.2h7.6l7.2,4.3,8.2,5.6,4.3,2.6,5.1,7.9,2.6,6.3v17.7l-2.6,27.1-.8,21s-58.5,29.1-136.6,0Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M177.1,147.2s-61.1,28.6-136.6,0l4.1,8.2s49.6,28.8,131.5,0l.9-8.3Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M177.8,140.4c-27.2,18.8-61.2,32.3-95,27.5-13.6-1.9-27.3-6.1-38-14.8s-7.7-11.9-11.2-17.8c-7.4-12.8-13-26.4-14.3-41.3s3.2-13.8,8-18.3l5.3-2.8c3-4,6.1-7.4,10.7-9.3,10.5-4.4,16.2-19,38.8-28.8,11.1-4.8,22.4,3.1,33.6,7.5s14.1,6.5,20,12.1c4.8,4.5,13.2-2.2,17.6.6l11.5,7.3c19.6,12.3,15.2,26.5,14.3,46.2l-1.4,32.1Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.3,390.6l18.9-29.4,4.2-5s47-47.3,119.9,2.4l.2,3.8,5.4,11.2,7.1,13.7s-28.5-.8-28.5,42.3H54.9s2.6-38.9-28.6-38.9h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M54.9,429.5v43.7l-20.9-14.9-12.3-10.9-3.5-9.3v-16.8l1.1-11.3,3.4-11,3.6-8.3s29.2-2.9,28.6,38.9h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M153.5,429.1v32.9l6.4,1,6.8-1,8.9-4.2,9.4-7,5.2-5.9,3.5-7,.9-7.1v-10.3l-1.9-9.2-3.3-9.4-3.8-8.7-3.5-6s-28.5-1.6-28.5,41.9h0Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '54.9 429.5 153.5 429.5 194.6 429.5 193.7 438 190.2 445 185 450.9 175.6 457.8 166.7 462 159.9 463.1 153.5 462 140.9 461.4 134 467.6 129.6 470.4 115.2 476.5 103.1 482 92.3 482 80.6 476.5 76.4 477.4 65.2 477.1 54.9 473.2 34 458.3 21.7 447.4 18.2 438.1 18.2 429.5 54.9 429.5',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M49.4,356.2s47.3-47.2,119.9,2.4v-8.9s-66.2-48.8-119.9-1.5v8.1h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.3,390.6l18.9-29.4,4.2-5s47.2-48,119.9,2.4l.2,3.8,12.5,24.9,7.3,14.7,3.3,9.4,1.9,9.2v8.9l-.9,8.5-3.5,7-5.2,5.9-9.4,7-8.9,4.2-6.8,1-6.4-1-12.6-.7-6.9,6.3-4.4,2.8-14.4,6.1-12.1,5.5h-10.7l-11.8-5.5-4.1.9-11.2-.3-10.3-4-20.9-14.9-12.3-10.9-3.5-9.3v-16.8l1.1-11.3,3.4-11,3.6-8.3h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.3,473.2c-15.7,5-20.3,12.4-32.3,6.8l-9.1-4.2c-10.2,1.6-20.9,1-29.6-5s-21.4-14.5-29.3-24.5-3.3-17.3-3-25.2c.4-13.3,3.9-25,11.2-36l19.2-28.6c11.2-14.4,27.7-21.5,45.8-21,28.4.7,55.8,17.3,78.1,34.5,10.6,21.6,23.1,36.2,20.9,62.2s-4.8,15.3-11.8,20.3-13,10.2-21.4,10l-10.4-.3-9.7-1.6c-5.2,5.9-11.1,10.3-18.5,12.7Z',
			},
		},
	},
};
